import _ from 'lodash';
import url from 'url';
import { Toast } from 'antd-mobile';
import { trackClick } from '@/utils/util';
import withModal from '@/components/WithModal';
import { getShareCoupon, loggedCoupon } from '@/services/api';

const pathMap =
{
  'netcar/index?needlogin=true': { desc: '跳转打车', protocol: 'crgt' },
  'netcar/index?needlogin=true&tab=rentcar': { desc: '跳转租车', protocol: 'crgt' },
  'openTab?tab=home': { desc: '跳转首页', protocol: 'action' },
  'openTab?tab=video': { desc: '跳转娱乐', protocol: 'action' },
  'openTab?tab=travel': { desc: '跳转行程', protocol: 'action' },
  'openTab?tab=mine': { desc: '跳转我的', protocol: 'action' },
}


const doNothing = () => {

};


function throttle(func, delay) {
  var timer = null;
  return function () {
    var context = this;
    var args = arguments;
    if (!timer) {
      func.apply(context, args);
      timer = setTimeout(function () {
        timer = null;
      }, delay);
    }
  }
}

// 打开视频详情
function openView(params) {
  // console.log('onclick params', params);
  const { cid, vid } = params;
  // console.log('onclick', cid, vid);
  const trackBody = {
    cid: Number(cid),
    vid: Number(vid),
    path: '打开视频详情',
    url: ''
  }
  // console.log('打开详情', trackBody)
  trackClick('p_exit_common_2', trackBody);
  if (!_.isNil(cid) && !_.isNil(vid)) {
    if (window.crgt.isCRGT) {
      window.crgt && window.crgt.router.openView({
        path: 'video/detail',
        params: {
          vid: _.trim(vid),
          cid: _.trim(cid)
        }
      });
    } else {
      toDownloadApp();
    }

  }

}

function parseUrlQuery(url) {
  const params = url.split('?')[1].split('&');
  let query = {};
  for (let i = 0; i < params.length; i++) {
    const pair = params[i].split('=');
    query[`${pair[0]}`] = pair[1];
  }
  return query;
}

// 打开原生页面
function openNativeView(params = {}) {
  // console.log('opennative view')
  const { nativePage, externalUrl } = params;
  console.log('externalUrl', externalUrl, nativePage)
  const trackBody = {
    cid: 0,
    vid: 0,
    path: pathMap[`${nativePage}`].desc,
    url: ''
  }

  let paramBody = {}
  const path = nativePage.split('?')[0];
  if (nativePage.includes('?')) {
    paramBody = parseUrlQuery(nativePage);
  }

  if (nativePage === 'netcar/index?needlogin=true&tab=rentcar') {
    const CANUSEVERSIONRENTCAR = '2.2.8';
    const isOldVersion = compare(CANUSEVERSIONRENTCAR) === -1;
    if (isOldVersion) {
      Toast.info('当前版本不支持，请更新至最新版本');
      return;
    }
  }

  trackClick('p_exit_common_2', trackBody);
  if (!_.isEmpty(path)) {
    if (window.crgt.isCRGT) {
      window.crgt.router.openProtocol({
        protocol: pathMap[`${nativePage}`].protocol,
        path,
        params: paramBody
      });

      // if(pathMap[`${nativePage}`].protocol === 'action'){
      //   window.crgt.router.popBack({
      //     force: 1
      //   })
      // }  
    } else if (window.crgt.isWXMp && nativePage === 'netcar/index?needlogin=true') {
      window.wx.miniProgram.navigateTo({
        url: '/pages/goTaxi/index',
      });
    } else {
      if (!(_.isEmpty(externalUrl))) {
        window.location.href = externalUrl
      } else {
        toDownloadApp()
      }
    }

  } else {
    if (!(_.isEmpty(externalUrl))) {
      window.location.href = externalUrl
    } else {
      toDownloadApp()
    }
  }
}
// 跳转下载页
function openDownload(params = {}) {
  //  https://static.ccrgt.com/download/?start_download=true&chid=12066
  // ${_baseUrl}/download/?openapp=true&chid=12066
  let searchParams = window.location.href.split('?')[1];
  searchParams = _.isNil(searchParams) ? '' : searchParams;
  const trackBody = {
    cid: 0,
    vid: 0,
    path: '跳转下载页',
    url: ''
  }
  // console.log(searchParams, trackBody)
  trackClick('p_exit_common_2', trackBody);
  const downloadUrl = `https://static.ccrgt.com/download/?${searchParams}`
  window.location.href = downloadUrl;
}

// 比较版本
function compare(supportVersion) {
  const ua = (typeof navigator !== 'undefined') ? navigator.userAgent : '';
  const REGEXP_CRGT = /com.crgt.ilife\/([\d.]+)/i;
  if (typeof window !== 'undefined') {
    if (REGEXP_CRGT.test(ua) || (window.crgt && window.crgt.isCRGT)) {
      return window.crgt.compare(supportVersion);
    }
  }

}

// 获取当前网络
function getNetworkType() {
  return new Promise((resolve, reject) => {
    window.crgt && window.crgt.device.getNetworkType().then(function (res) {
      if (res && res.code === 0 && res.data) {
        resolve(res.data.type)
      }
    }).catch((err) => {
      reject(err)
    })
  })

}

// 跳转H5链接
function openUrl(params) {
  // console.log('onclick params', params);
  const { url, target } = params;
  const trackBody = {
    cid: 0,
    vid: 0,
    path: url,
    url: ''
  }
  // console.log('跳转url', trackBody)
  trackClick('p_exit_common_2', trackBody);
  // console.log('onclick', url, target);
  if (!(_.isEmpty(url))) {
    if ((Number(target) === 3)) {
      window.location.href = url;
    }
    else {
      window.crgt && window.crgt.router.openUrl({
        url,
        target: target || 1
      });
    }

  }

}


// 去跳转外部地址 默认下载地址
function toDownloadApp() {
  const externalLink = window._externalLink;
  if (!_.isEmpty(externalLink)) { window.location.href = externalLink; }
}

// 分享小程序
function getShareInfo(params) {
  const { type, style, title, desc, link, imgUrl, path, userName } = params
  const info = {
    type: Number(type),
    style: Number(style) || 0,
    title,
    desc: desc || '',
    link: link || '',
    imgUrl: imgUrl || '',
    path: path ? (url.format({
      pathname: '/pages/activity/index',
      query: {
        url: path,
        requireUserInfo: 'true',
      },
    })) : '',
    userName: userName || 'gh_345c5d37f42f',
  }
  return info;
}

// 直接分享到微信
export function shareTo(params) {
  const shareInfo = getShareInfo(params);
  window.crgt.share.shareTo(shareInfo);
}

// 显示分享面板
export function showShareMenu(shareInfo, callback) {
  const { isCRGT } = window.crgt
  console.log('shareInfo', shareInfo)
  if (isCRGT) {
    window.crgt.share.showShareMenu(
      shareInfo
    ).then((res) => {
      if (res && res.code === 0) {
        trackClick('p_open_common_5', res.data);

        if (typeof callback === 'function') {
          callback();
        }
      }
    })
  }
}
export async function setShareAccountLocalStorage() {

  const userInfo = await window.crgt.data.getUserInfo();
  const { data: { accountId } } = userInfo;
  if (_.isNil(accountId)) { return; }
  // key 加上pageID，这个活动分享过 TODO
  window.localStorage.setItem(`__SHARE_${window._activityKey}__`, accountId)
}

export async function shareAndGrantCoupon({ shareInfo, modalInfo }) {
  // 支持分享，分享后存localStorage, 
  // localStorage 查到即可请求API，发券。
  // 根据API结果， 提示Toast 或者 成功发券弹窗
  const { isCRGT } = window.crgt

  const token = await window.crgt.getToken();
  if (token) {
    showShareMenu(shareInfo, () => grantCoupon(modalInfo))
  } else {
    if (isCRGT) {
      await window.crgt.router.openLogin();
      window.location.reload();
    } else {

      toDownloadApp()
    }
  }
}
async function grantCoupon(modalInfo) {
  const res = await getShareCoupon();
  if (res.code === 0) {
    if (Number(res.data.status) === 0) {
      withModal.show(res.data.prizes, modalInfo);
    } else {
      Toast.info(res.data.message);
    };
  }
}

export function setRightButton(params) {
  if (window.crgt.isCRGT)
    window.crgt && window.crgt.ui.setRightButton({
      items: [{
        icon: 'data:image/png;base64,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'
      }],
      onClick: () => {
        showShareMenu(params);
      }
    })

}

export function setTitle({ title, color }) {
  if (window.crgt.isCRGT) {
    window.crgt && window.crgt.ui.setTitle({
      title: title,
      color: color || '#000000'
    })
  }
}

// 打开音频详情页 
export function openAudio(params) {
  const { cid } = params;
  const CANUSEVERSION = '2.1.3';
  const isOldVersion = compare(CANUSEVERSION) === -1;
  if (isOldVersion) {
    Toast.info('当前版本不支持，请更新至最新版本');
    return;
  }
  const trackBody = {
    cid: Number(cid),
    vid: 0,
    path: '跳转至音频详请',
    url: ''
  }
  // console.log('打开详情', trackBody)
  trackClick('p_exit_common_2', trackBody);
  if (!_.isNil(cid)) {
    if (window.crgt.isCRGT) {
      window.crgt && window.crgt.router.openView({
        path: 'audio/album',
        params: {
          cid: _.trim(cid),
          direct_buy: false
        }
      });
    } else {
      toDownloadApp();
    }

  }

}

// 跳转娱乐指定频道
export function openVideoChannel(params) {
  const { nativePath } = params;
  const path = parsePathQuery(nativePath);
  console.log('nativePath', nativePath, path)
  const trackBody = {
    cid: 0,
    vid: 0,
    url: nativePath,
    path: '跳转娱乐指定频道'
  }

  // console.log('打开详情', trackBody)
  trackClick('p_exit_common_2', trackBody);
  const CANUSEVERSION = '2.2.6';
  const isOldVersion = compare(CANUSEVERSION) === -1;
  if (isOldVersion) {
    Toast.info('当前版本不支持，请更新至最新版本');
    return;
  }

  if (!_.isEmpty(path)) {
    if (window.crgt.isCRGT) {
      window.crgt.router.openProtocol({
        protocol: 'action',
        path: 'openTab',
        params: {
          tab: 'video',
          ...path
        }
      });
    } else {
      toDownloadApp();
    }

  }

}

// 跳转至单本小说
export function openReader(params) {
  const { nativePath } = params;
  const path = parsePathQuery(nativePath);
  console.log('nativePath', nativePath, path)
  const trackBody = {
    cid: 0,
    vid: 0,
    url: nativePath,
    path: '跳转至小说单本'
  }
  // console.log('打开详情', trackBody)
  trackClick('p_exit_common_2', trackBody);
  const CANUSEVERSION = '2.2.6';
  const isOldVersion = compare(CANUSEVERSION) === -1;
  if (isOldVersion) {
    Toast.info('当前版本不支持，请更新至最新版本');
    return;
  }

  if (!_.isEmpty(path)) {
    if (window.crgt.isCRGT) {
      window.crgt.router.openProtocol({
        protocol: 'crgt',
        path: 'jumpToReader',
        params: {
          ...path
        }
      });
    } else {
      toDownloadApp();
    }
  }
}

export function parsePathQuery(path) {
  let params = _.trim(path).split('&');
  let query = {}
  for (let i = 0; i < params.length; i++) {
    const pair = params[i].split('=');
    query[`${pair[0]}`] = decodeURIComponent(pair[1])
  }
  return query;

}

export async function grantCouponByLogged() {
  const token = await window.crgt.getToken();
  if (token) {
    const res = await loggedCoupon({});
    return res;
  } else {
    return;
  }

}
export default {
  doNothing: throttle(doNothing, 2000),
  openView: throttle(openView, 2000),
  openNativeView: throttle(openNativeView, 2000),
  openDownload: throttle(openDownload, 2000),
  openUrl: openUrl,
  compare: compare,
  getNetworkType: getNetworkType,
  setRightButton: setRightButton,
  shareAndGrantCoupon: shareAndGrantCoupon,
  setTitle: setTitle,
  openAudio: openAudio,
  grantCouponByLogged: grantCouponByLogged,
  openReader: openReader,
  openVideoChannel: openVideoChannel
}